import { RootState } from '../../../../rootReducer';

export const searchCodesSelector = (state: RootState) => state.operationsModuleReducer.SearchCodesReducer;
